import React, { Component } from 'react';

class Resume extends Component {
  render() {

    if(this.props.data){
      var education = this.props.data.education.map(function(education){
        return <div key={education.school}><h3>{education.school}</h3>
        <p className="info">{education.degree} <span>&bull;</span><em className="date">{education.graduated}</em></p>
        <p>{education.description}</p></div>
      })
      var work = this.props.data.work.map(function(work){
        return <div key={work.title}><h3>{work.company}</h3>
            <p className="info">{work.title}<span>&bull;</span> <em className="date">{work.years}</em></p>
            <p>{work.description}</p>
            <p>{work.descriptions}</p>
        </div>
      })
    }

    return (
      <section id="resume">

      <div className="row education">
         <div className="three columns header-col">
            <h1><span>Education</span></h1>
         </div>

         <div className="nine columns main-col">
            <div className="row item">
               <div className="twelve columns">
                 {education}
               </div>
            </div>
         </div>
      </div>


      <div className="row work">

         <div className="three columns header-col">
            <h1><span>Work Experience</span></h1>
         </div>

         <div className="nine columns main-col">
          {work}
        </div>
      </div>
      <div className="row work">

         <div className="three columns header-col">
            <h1><span>Tech Stack</span></h1>
         </div>

         <div className="nine columns main-col">
         <img src="https://img.icons8.com/color/480/000000/git.png" height="50" width="50"></img>&nbsp;
         <img src="https://img.icons8.com/color/256/java-coffee-cup-logo.png" height="50" width="50"></img>&nbsp;
         <img src="https://img.icons8.com/color/480/000000/python.png" height="50" width="50"></img>&nbsp;
         <img src="https://img.icons8.com/color/480/000000/c-plus-plus-logo.png" height="50" width="50"></img>&emsp;
         <img src="https://img.icons8.com/color/480/000000/react-native.png" height="50" width="50"></img>&nbsp;         
         <img src="https://img.icons8.com/color/480/000000/nodejs.png" height="50" width="50"></img>&nbsp;
         <img src="https://img.icons8.com/color/480/000000/javascript.png" height="50" width="50"></img>&nbsp;
         <img src="https://img.icons8.com/color/480/000000/django.png" height="50" width="50"></img>&nbsp;         
         <img src="https://img.icons8.com/color/480/000000/google-cloud.png" height="50" width="50"></img>&emsp;
         <img src="https://img.icons8.com/color/480/000000/mongodb.png" height="50" width="50"></img>&nbsp;
         <img src="https://img.icons8.com/color/480/000000/mysql-logo.png" height="50" width="50"></img>&nbsp;         
        </div>
      </div>



      
   </section>
    );
  }
}

export default Resume;
